import { ReactNode } from "react";
import Instrument from "./Instrument";
import GuitarAcoustic from "ui/icons/instruments/acoustic-guitar";
import BassGuitar from "ui/icons/instruments/bass-guitar";
import SnareDrum from "ui/icons/instruments/snare-drum";
import Synth from "ui/icons/instruments/synthesizer";

export type InstrumentsConfig = {
  [instrument in Instrument]: {
    name: string;
    shortName: string;
    instrument: Instrument;
    icon: (props: { className: string }) => ReactNode;
  };
};

// use as short of names as possible
export const instrumentsConfig: InstrumentsConfig = {
  // gtrs
  [Instrument.gtrAccFingerPicked]: {
    name: "Fingerstyle Guitar",
    shortName: "Gtr.Fngr",
    instrument: Instrument.gtrAccFingerPicked,
    icon: ({ className }) => <GuitarAcoustic className={className} />,
  },
  [Instrument.gtrAccStrummed]: {
    name: "Strummed Ac. Guitar",
    shortName: "Gtr.Strm",
    instrument: Instrument.gtrAccStrummed,
    icon: ({ className }) => <GuitarAcoustic className={className} />,
  },
  [Instrument.gtrAccLead]: {
    name: "Lead Ac. Guitar",
    shortName: "Gtr.Lead",
    instrument: Instrument.gtrAccLead,
    icon: ({ className }) => <GuitarAcoustic className={className} />,
  },
  // basses
  [Instrument.gtrBass]: {
    name: "Bass Guitar",
    shortName: "Bass",
    instrument: Instrument.gtrBass,
    icon: ({ className }) => <BassGuitar className={className} />,
  },
  // drums
  [Instrument.drmSet]: {
    name: "Drum Set",
    shortName: "Drms",
    instrument: Instrument.drmSet,
    icon: ({ className }) => <SnareDrum className={className} />,
  },
  [Instrument.drmKick]: {
    name: "Kick Drum",
    shortName: "Kck",
    instrument: Instrument.drmKick,
    icon: ({ className }) => <SnareDrum className={className} />,
  },
  [Instrument.drmSnare]: {
    name: "Snare Drum",
    shortName: "Snre",
    instrument: Instrument.drmSnare,
    icon: ({ className }) => <SnareDrum className={className} />,
  },
  [Instrument.drmOh]: {
    name: "Overhead Drum",
    shortName: "Drms.OH",
    instrument: Instrument.drmOh,
    icon: ({ className }) => <SnareDrum className={className} />,
  },
  // synths
  [Instrument.synthPad]: {
    name: "Synth Pad",
    shortName: "Pad",
    instrument: Instrument.synthPad,
    icon: ({ className }) => <Synth className={className} />,
  },
  [Instrument.synthLead]: {
    name: "Synth Lead",
    shortName: "Synth",
    instrument: Instrument.synthLead,
    icon: ({ className }) => <Synth className={className} />,
  },
  [Instrument.percBongos]: {
    name: "Bongos",
    shortName: "Bngo",
    instrument: Instrument.percBongos,
    icon: ({ className }) => <SnareDrum className={className} />, // TODO: replace with bongo icon
  },
  [Instrument.percShaker]: {
    name: "Shaker",
    shortName: "Shkr",
    instrument: Instrument.percShaker,
    icon: ({ className }) => <SnareDrum className={className} />, // TODO: replace with shaker icon
  },
  [Instrument.percTambo]: {
    name: "Tambourine",
    shortName: "Tambo",
    instrument: Instrument.percTambo,
    icon: ({ className }) => <SnareDrum className={className} />, // TODO: replace with tambourine icon
  },
  // strings
  [Instrument.stringEnsemble]: {
    name: "String Ensemble",
    shortName: "Ensemble",
    instrument: Instrument.stringEnsemble,
    icon: ({ className }) => <GuitarAcoustic className={className} />, // TODO: replace with string ensemble icon
  },
  // vox
  [Instrument.voxFemale]: {
    name: "Female Vocals",
    shortName: "Female Vox",
    instrument: Instrument.voxFemale,
    icon: ({ className }) => <SnareDrum className={className} />, // TODO: replace with vox icon
  },
};
